import { Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { DrilldownContainerChartSize } from '@models';

@Component({
  selector: 'drilldown-chart-container',
  templateUrl: './drilldown-chart-container.component.html',
  styleUrl: './drilldown-chart-container.component.scss'
})
export class DrilldownChartContainerComponent {
  @Input() title!: string | undefined;
  @Input() infoText?: string;
  @Input() size!: DrilldownContainerChartSize;
  @Input() isLoading!: boolean | undefined;
  @Output() expandChartClicked = new EventEmitter<void>();
  @ContentChild('chart-element', { static: false }) chartElement!: ElementRef;

  infoTooltipOpen = false;

  onExpandChartClicked() {
    this.expandChartClicked.emit();
  }

  getSkeletonLoaderHeight(): string {
    switch (this.size) {
      case 'small':
        return '100px';
      case 'medium':
        return '260px';
    }
  }

  getSkeletonLoaderWidth(): string {
    switch (this.size) {
      case 'small':
        return '328px';
      case 'medium':
        return '648px';
    }
  }
}
